import React, { Component } from 'react';
import FormBuilder from './FormBuilder.js';
import PropFinder from './PropFinder.js';
import SideBar from './SideBar.js';
import TabNavs from './TabNavs.js';
import AdminForm from './AdminForm.js';
import UserAdmin from './UserAdmin.js';
import NewProjectForm from './NewProjectForm.js';
import { Button, Col, Row } from 'reactstrap';

class PMFViewer extends Component {
	render() {
		if (this.props.loading) {
			return (
				<div className="loadingContainer">
					<h4>Loading... {this.props.uploadProgress}</h4>
					<img className="touchy" src={this.props.touchy} />
				</div>
			);

		}
		switch (this.props.section) {
			case 'SPLASH':
				return (
					<div className="viewContainer centered">
						<PropFinder
							fuzzyFindValue={this.props.fuzzyFindValue}
							handleFuzzyChange={this.props.handleFuzzyChange}
							isBetterArray={this.props.isBetterArray}
							searchResults={this.props.searchResults}
							handleGetFuzzy={this.props.handleGetFuzzy}
							handleGetRouteFromSearch={this.props.handleGetRouteFromSearch} />
					</div>
				);
			case 'PROJECT':
			case 'PROGRAM':
			case 'HARDWARE':
				return (
					<div className="viewContainer">
						<SideBar
							section={this.props.section}
							changeSection={this.props.changeSection}
							themeSwap={this.props.themeSwap}
							themeName={this.props.themeName}
							themeRed={this.props.themeRed}
						/>
						<Row className="noMargin">
							<Col xs="11" className="mainCont">
								<Row>
									<Col xs={2} />
									<Col xs={6} />
									<Col xs={2}>
										<Button
											className="save-btn rounded-0 button"
											onClick={this.props.writeData}
										>
											Save Changes
									</Button>
									</Col>
									<Col xs={2}>
										<Button
											className="save-btn rounded-0 button"
											onClick={() => {
												let propNum = this.props.routeData.property_number;
												return this.props.barbarianReq(propNum);
											}}
										>
											Run Barbarian
									</Button>
									</Col>
									<Col className="botRtCorner">
										<div className="redMode"><button onClick={() => this.props.themeRed()}>RED</button></div>

										<Button
											className="save-btn rounded-0 button"
											onClick={this.props.toggleDBView}
										>
											Show Database Labels
									</Button>
									</Col>
								</Row>

								<FormBuilder
									section={this.props.section}
									programForm={this.props.programForm}
									projectForm={this.props.projectForm}
									hardwareForm={this.props.hardwareForm}
								/>
							</Col>
						</Row>
					</div>
				);
			case 'ADMIN':
				return (
					<div className="viewContainer adminCont">
						<Row className="noMargin">
							<Col>
								<AdminForm
									adminUpdate={this.props.adminUpdate}
									adminWrite={this.props.adminWrite}
									changeSubsection={this.props.changeSubsection}
									handleAdminValueChange={this.props.handleAdminValueChange}
									makeAdminTable={this.props.makeAdminTable}
									section={this.props.section}
									subsection={this.props.subsection}
									adminData={this.props.adminData}
								/>
							</Col>
						</Row>
					</div>
				);
			case 'USER':
				return (
					<div className="viewContainer adminCont">
						<Row className="noMargin">
							<Col>
								<UserAdmin
									md5GetQueryParams={this.props.md5GetQueryParams}
									forgotPasswordRequest={this.props.forgotPasswordRequest}
								/>
							</Col>
						</Row>
					</div>
				);
			case 'LOADING':
			default:
				console.log('LOADING PROPS: ', this.props.uploadProgress);
				return (
					<div className="loadingContainer">
						<h4>Loading... {this.props.uploadProgress}</h4>
						<img className="touchy" src={this.props.touchy} />
					</div>
				);
		}
	}
}

export default PMFViewer;



// WEBPACK FOOTER //
// ./src/components/PMFViewer.js